import React from 'react';

import Field, { hasDataInFields } from '../../containers/PageBuilder/Field';
import SectionContainer from '../../containers/PageBuilder/SectionBuilder/SectionContainer';

import {
  AUSGANGSLAGE,
  EYEBROW,
  IDEE,
  KI,
  KONTAKT_BLOCK,
  LEAD,
  TRANSPARENZ,
  ZIELE,
} from '../aboutPage';
import gem from '../salesPage.module.css';
import css from './SectionAbout.module.css';

/**
 * FairwayBid: "Über uns".
 *
 * Vorher neun gleich aussehende Textabschnitte hintereinander, der
 * wichtigste ganz unten. Wichtig ist hier aber nicht alles gleich viel.
 *
 * Der Aufbau folgt jetzt dem, was der Text erzählt: erst das Problem, und
 * zwar von beiden Seiten nebeneinander, weil genau das der Punkt ist; dann
 * die Idee als dunkle Fläche über die volle Breite, weil sie die Pointe ist;
 * dann Ziele und KI als Karten; und vor dem Schluss die Transparenznotiz.
 *
 * Die ist bewusst klein gehalten. Sie beantwortet eine Frage, die sich ein
 * Clubmanager stellt - aber ein Absatz, der sich lange rechtfertigt, weckt
 * genau den Verdacht, den er ausräumen soll.
 *
 * Überschrift aus der Console, Inhalt aus aboutPage.js.
 */
const SectionAbout = props => {
  const { sectionId, className, rootClassName, title, appearance, callToAction, options } = props;

  const fieldComponents = options?.fieldComponents;
  const fieldOptions = { fieldComponents };
  const hasHeaderFields = hasDataInFields([title, callToAction], fieldOptions);

  return (
    <SectionContainer
      id={sectionId}
      className={className}
      rootClassName={rootClassName}
      appearance={appearance}
      options={fieldOptions}
    >
      {hasHeaderFields ? (
        <header className={gem.header}>
          <span className={gem.eyebrow}>{EYEBROW}</span>
          <Field data={title} className={gem.headTitle} options={fieldOptions} />
          <span className={gem.rule} aria-hidden="true" />
          <p className={gem.intro}>{LEAD}</p>
        </header>
      ) : null}

      <div className={gem.wrap}>
        <h2 className={gem.blockTitle}>{AUSGANGSLAGE.titel}</h2>
        <div className={css.seiten}>
          {AUSGANGSLAGE.seiten.map(s => (
            <article key={s.key} className={css.seite}>
              <span className={css.rolle}>{s.rolle}</span>
              <h3 className={css.seiteHeadline}>{s.headline}</h3>
              <p className={css.seiteText}>{s.text}</p>
            </article>
          ))}
        </div>
        <p className={css.fazit}>{AUSGANGSLAGE.fazit}</p>
      </div>

      {/* Die Pointe - dunkel und ueber die volle Breite, wie auf der Seite fuer Golfanlagen. */}
      <div className={css.idee}>
        <div className={css.ideeInner}>
          <p className={css.ideeKern}>{IDEE.kern}</p>
          {IDEE.absaetze.map(a => (
            <p key={a.slice(0, 30)} className={css.ideeText}>
              {a}
            </p>
          ))}
        </div>
      </div>

      <div className={gem.wrap}>
        <h2 className={gem.blockTitle}>{ZIELE.titel}</h2>
        <div className={css.ziele}>
          {ZIELE.punkte.map(z => (
            <div key={z.label} className={css.ziel}>
              <h3 className={css.zielLabel}>{z.label}</h3>
              <p className={css.zielText}>{z.text}</p>
            </div>
          ))}
        </div>

        <h2 className={gem.blockTitle}>{KI.titel}</h2>
        <p className={css.kiLead}>{KI.lead}</p>
        <div className={gem.features}>
          {KI.punkte.map(p => (
            <article key={p.label} className={gem.feature}>
              <div>
                <h3 className={gem.featureHeadline}>{p.label}</h3>
                <p className={gem.featureText}>{p.text}</p>
              </div>
            </article>
          ))}
        </div>
        <p className={css.grenze}>{KI.grenze}</p>

        {/*
          Knapp und ohne grossen Auftritt: Ein Absatz, der sich lange
          rechtfertigt, weckt genau den Verdacht, den er ausraeumen soll.
          Die Antwort steht in der ersten Zeile, der Rest ist Begruendung.
        */}
        <aside className={css.notiz}>
          <span className={css.notizEyebrow}>{TRANSPARENZ.eyebrow}</span>
          <p className={css.notizFrage}>
            {TRANSPARENZ.frage} <strong className={css.notizAntwort}>{TRANSPARENZ.antwort}</strong>
          </p>
          <p className={css.notizText}>{TRANSPARENZ.text}</p>
          <p className={css.notizPruefbar}>{TRANSPARENZ.pruefbar}</p>
        </aside>

        <section className={css.kontakt}>
          <h2 className={css.kontaktTitel}>{KONTAKT_BLOCK.titel}</h2>
          <p className={css.kontaktText}>{KONTAKT_BLOCK.text}</p>
          <a className={css.kontaktMail} href={`mailto:${KONTAKT_BLOCK.email}`}>
            {KONTAKT_BLOCK.email}
          </a>
        </section>
      </div>
    </SectionContainer>
  );
};

export default SectionAbout;
